import * as React from 'react';

declare module 'react' {
    interface HTMLAttributes<T> {
        page_id?: string;
        attribution?: string;
        theme_color?: string;
        logged_in_greeting?: string;
        logged_out_greeting?: string;
        minimized?: string;
    }
}

const CustomerChat = (
    {color, customClass = '', pageId, messageToUserHasLogged, messageToUserHasNotLogged, minimized}
    ) =>
    <div className={`fb-customerchat ${customClass ? customClass : ''}`}
         attribution="setup_tool"
         page_id={pageId}
         theme_color={color}
         logged_in_greeting={messageToUserHasLogged}
         logged_out_greeting={messageToUserHasNotLogged}
         minimized={minimized}>
    </div>
;

export default CustomerChat;
